import React, { useState } from 'react';
import styles from './styles.module.scss';
import { Link, useNavigate } from 'react-router-dom';
// import Footer from '../../Footer/Footer';
import { PaymentModal } from '../../PaymentModal';
import { useAuth } from '../../../context/AuthContext';
import { useSelector } from 'react-redux';
import { BASEPATH } from '../../../lib/constants';
import Button from '../../Button';
import { useMediaQuery } from 'react-responsive';
import youtube from '../../../assets/build-resume-home/footer/youtube.png';
import linkedin from '../../../assets/build-resume-home/footer/linkedin.png';


const Mobile = (props) => {

  const { authState, loading } = useAuth();
  console.log('authState', authState);
  const data = useSelector(state => state);
  console.log('store data', data.cache?.location);
  const navigate = useNavigate();
  const isPaid = authState?.paymentSessionId;
  const [open, setOpen] = useState(false);
  const isIndia = BASEPATH.includes('/in') ? true : false;

  const Footer = () => {

    const navigate = useNavigate();

    const termsPopup = () => {
        navigate("/terms-of-service");
    }

    const privacyPopup = () => {
        navigate("/privacy-policy");
    }

    return (
      <>
        <footer className={styles.footer}>
          <div className={styles.contentWrap}>
            <div className={styles.copyRight}>© Copyright {new Date().getFullYear()}. Paññã. All rights reserved</div>
            <div onClick={() => privacyPopup()} className={styles.privacy}>Privacy</div>
            <div onClick={() => termsPopup()} className={styles.privacy}>Terms</div>
            <a id="supportMail" href="mailto:support@panna.ai" className={styles.reachOut}>support@panna.ai</a>

            <div className={styles.socialLinks}>
              <a id="pannawayLinkedin" href="https://www.linkedin.com/company/pannaway/" target="_blank" rel="noopener noreferrer">
                <img src={linkedin} alt="" className={styles.socialLink} />
              </a>
              <a id="pannaYoutube" href="https://www.youtube.com/channel/UCOMclJ0qdIbGonee1r-hGWQ" target="_blank" rel="noopener noreferrer">
                <img src={youtube} alt="" className={styles.socialLink} />
              </a>
            </div>
          </div>
        </footer>
      </>
    );
  };



  const handleBuildResume = () => {
    if (!authState) {
      navigate('/signup');
      return;
    }

    const emailList = ['tejaswini.vemulapally@mroads.com', 'madhav.vs@mroads.com', 'santhosh.bolla@yopmail.com', 'venkatakrishna.avula@mroads.com', 'lalitha.jampana@mroads.com', 'pradeep.dantuluri@mroads.com']
    const skipPayment = emailList.includes(authState?.userInfo?.emailAddress);
    console.log('skipPayment:', skipPayment);
    if (isPaid || skipPayment) {
      navigate('/resume-builder');
    } else {
      setOpen(true);
    }
  };

  const PurchaseSection = (props) => {
    const { isIndia, handleBuildResume } = props;

    return (
      <div className={styles.content3}>
        <div className={styles.text}>
          Get started <br /> transforming your <br /> resume today!
        </div>
        {isIndia ? (
          <div className={styles.heading}>

            <span className={styles.priceNew}>₹499</span> <span className={styles.onlyText}>Only</span>
          </div>
        ) : (
          <div className={styles.heading}>
            <span className={styles.priceNew}>$4.99</span> <span className={styles.onlyText}>Only</span>
          </div>
        )}
        <div className={styles.btnContainer}>
          <button className={styles.primaryButton}
            id="optimize-My-Resume-Now2"
            onClick={() => {
              handleBuildResume();
            }}
          >
            Optimize My Resume Now
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.footerContainer}>
      <PurchaseSection
        isIndia={isIndia}
        handleBuildResume={handleBuildResume}
      />
      <Footer />
      <PaymentModal open={open} setOpen={setOpen} />
    </div>
  );
}



export default Mobile;
